import { DashboardDefectsByAsset } from '@/store/metrics/types';

export default function getObservationsFromQuery(
  query: any,
  dashboardDefects: DashboardDefectsByAsset[],
): string[] {
  if (!query || !dashboardDefects) {
    return [];
  }
  const assetType = decodeURI(query.assetType);
  const querySearch = decodeURI(query.search);

  const searchableDefectKeys = [
    query.codeDisplay ?? 'code',
    'grade',
    'type',
  ];

  return dashboardDefects
    .filter((asset) => {
      if (asset.assetType !== assetType) {
        return false;
      }
      if (
        !asset.defects.some((defect) => {
          if (!query.defectCode.includes(defect.code)) {
            return false;
          }
          if (
            !query.defectGrade.includes(
              defect.grade.toString().toLowerCase() === 'unscored'
                ? '-1'
                : defect.grade.toString(),
            )
          ) {
            return false;
          }
          return true;
        })
      ) {
        return false;
      }
      if (querySearch) {
        if (asset.assetName.includes(querySearch)) {
          return true;
        }
        return asset.defects.some((defect) => searchableDefectKeys
          .some((key) => defect[key] && defect[key].toString().includes(querySearch)));
      }
      return true;
    })
    .map((asset) => asset.assetName);
}
